import { jwtDecode } from "jwt-decode";

interface JwtPayload {
  sub: string; // Typically, the user ID is stored in the 'sub' (subject) claim
  name?: string;
  exp?: number;
  iat?: number;
  userData?:any;
  [key: string]: any;
}

class AuthService {
  static parseJwt(token: string): JwtPayload | null {
    try {
      return jwtDecode<JwtPayload>(token);
    } catch (error) {
      console.error('Invalid token', error);
      return null;
    }
  }

  static getCurrentUserId(): string | null {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      return null;
    }
    
    const decodedToken = this.parseJwt(token);
    const userDataString = decodedToken?.["http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata"];

    if (!userDataString) {
      return null;
    }

    const userData: any = JSON.parse(userDataString);
    return userData.Id ?? null;
  }

  static getCurrentUserPersonId(): number | undefined {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      return undefined;
    }
    
    const decodedToken = this.parseJwt(token);
    const userDataString = decodedToken?.["http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata"];

    if (!userDataString) {
      return undefined;
    }

    const userData: any = JSON.parse(userDataString);
    return userData.Person?.Id ?? undefined; // Adjust to match the casing of the property in your data
  }

  static getCurrentUserRoleId(): number | undefined {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      return undefined;
    }
    
    const decodedToken = this.parseJwt(token);
    const userDataString = decodedToken?.["http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata"];

    if (!userDataString) {
      return undefined;
    }

    const userData: any = JSON.parse(userDataString);
    return userData.Role?.Id ?? undefined; 
  }
  static getCurrentUserRole(): any | undefined {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      return undefined;
    }
    
    const decodedToken = this.parseJwt(token);
    const userDataString = decodedToken?.["http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata"];

    if (!userDataString) {
      return undefined;
    }

    const userData: any = JSON.parse(userDataString);
    return userData.Role ?? undefined; 
  }
}

export default AuthService;